import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchFidelityUpgradePlan } from 'slices/contract'
import { formatCurrenctyWithoutSignal } from 'utils'
import { Button } from 'components'
import { setDrawer } from 'slices/drawer'
import { DRAWER_KEY, FIDELITY_BANNER_DESKTOP, FIREBASE_EVENTS } from 'app-constants'
import { useFirebaseEvent } from 'hooks'
import './style.scss'

export function FidelityBanner() {
  const {
    selected: { id: contractId },
    fidelity,
  } = useSelector(({ contract }) => contract)
  const { isEligible, availablePlans = [] } = fidelity || {}
  const [plan] = availablePlans
  const { sendEvent } = useFirebaseEvent()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchFidelityUpgradePlan(contractId))
  }, [contractId, dispatch])

  function handleButtonClick() {
    sendEvent(FIREBASE_EVENTS.CLICK_ON_UPGRADE_PLAN)
    dispatch(setDrawer(DRAWER_KEY.FIDELITY))
  }

  function renderBanner() {
    return (
      <div className='fidelity-banner'>
        <img src={FIDELITY_BANNER_DESKTOP} alt='Banner de upgrade de plano' className='banner' />
        <div className='details'>
          <span className='description'>
            <strong>Turbine</strong> sua <br />
            conexão com
          </span>
          <div className='name'>{plan.velocity}</div>
          <span className='value'>
            por R$ <strong>{formatCurrenctyWithoutSignal(plan.value)}</strong>/mês
          </span>
        </div>
      </div>
    )
  }

  if (!isEligible || !plan) return null

  return (
    <div className='fidelity-banner-container'>
      {renderBanner()}
      <div className='info'>
        <h3 className='title'>Turbine sua conexão!</h3>
        <p className='description'>
          Com <strong>{plan.velocity}</strong> você tem mais velocidade, mais desempenho e muito
          mais internet pra sua rotina.
        </p>
        <Button className='know-more-button' color='primary' onClick={handleButtonClick}>
          Saiba mais
        </Button>
      </div>
    </div>
  )
}
